module.exports = __webpack_public_path__ + "static/23-401f8293e53506c973ee20b4cf12dd9a.jpeg";